(function () {

  // -------------------------
  // UTILS
  // -------------------------

  function getParticipantProps(itemKey) {
    return fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const item = cart.items.find(i => i.key === itemKey);
        return item ? { properties: item.properties, quantity: item.quantity, line: item } : null;
      });
  }

  function parseParticipants(properties) {
    const participants = [];
    let i = 1;
    while (true) {
      const nome    = properties['Partecipante ' + i + ' - Nome'];
      const cognome = properties['Partecipante ' + i + ' - Cognome'];
      const email   = properties['Partecipante ' + i + ' - Email'];
      if (nome === undefined) break;
      participants.push({ nome, cognome, email });
      i++;
    }
    return participants;
  }

  function buildPropertiesFromParticipants(participants) {
    const props = {};
    participants.forEach((p, idx) => {
      const n = idx + 1;
      props['Partecipante ' + n + ' - Nome']    = p.nome;
      props['Partecipante ' + n + ' - Cognome'] = p.cognome;
      props['Partecipante ' + n + ' - Email']   = p.email;
    });
    return props;
  }

  // -------------------------
  // MODAL HTML
  // -------------------------

  function createModal() {
    if (document.getElementById('participant-cart-modal')) return;
    const modal = document.createElement('div');
    modal.id = 'participant-cart-modal';
    modal.className = 'pcm-overlay';
    modal.innerHTML = `
      <div class="pcm-dialog" role="dialog" aria-modal="true">
        <div class="pcm-header">
          <span class="pcm-title">Dati partecipanti</span>
          <button class="pcm-close" aria-label="Chiudi">&#x2715;</button>
        </div>
        <div class="pcm-body"></div>
        <div class="pcm-footer">
          <div class="pcm-error">Compila i dati di tutti i partecipanti prima di confermare.</div>
          <button class="pcm-confirm button accent"><span>Conferma e aggiorna carrello</span></button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.querySelector('.pcm-close').addEventListener('click', closeModal);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });
  }

  function openModal() {
    const modal = document.getElementById('participant-cart-modal');
    if (modal) {
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal() {
    const modal = document.getElementById('participant-cart-modal');
    if (modal) {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  // -------------------------
  // RENDER GROUPS
  // -------------------------

  function renderGroups(container, participants, newQty) {
    container.innerHTML = '';
    for (let i = 0; i < newQty; i++) {
      const p = participants[i] || { nome: '', cognome: '', email: '' };
      const isNew = i >= participants.length;
      const group = document.createElement('div');
      group.className = 'pcm-group' + (isNew ? ' pcm-group--new' : '');
      group.innerHTML = `
        <div class="pcm-group-heading">
          <div class="pcm-group-number">${i + 1}</div>
          <span>Partecipante ${i + 1}</span>
          ${isNew ? '<span class="pcm-group-badge">Nuovo</span>' : ''}
        </div>
        <div class="pcm-group-fields">
          <div class="pcm-field">
            <label>Nome</label>
            <input type="text" data-field="nome" placeholder="Mario" value="${p.nome || ''}">
          </div>
          <div class="pcm-field">
            <label>Cognome</label>
            <input type="text" data-field="cognome" placeholder="Rossi" value="${p.cognome || ''}">
          </div>
          <div class="pcm-field pcm-field--full">
            <label>Email</label>
            <input type="email" data-field="email" placeholder="mario.rossi@email.com" value="${p.email || ''}">
          </div>
        </div>
      `;
      container.appendChild(group);
    }
  }

  function renderGroupsWithRemoval(container, participants, newQty) {
    container.innerHTML = '';
    for (let i = 0; i < newQty; i++) {
      const p = participants[i] || { nome: '', cognome: '', email: '' };
      const group = document.createElement('div');
      group.className = 'pcm-group';
      group.innerHTML = `
        <div class="pcm-group-heading">
          <div class="pcm-group-number">${i + 1}</div>
          <span>Partecipante ${i + 1}</span>
        </div>
        <div class="pcm-group-fields">
          <div class="pcm-field">
            <label>Nome</label>
            <input type="text" data-field="nome" placeholder="Mario" value="${p.nome || ''}">
          </div>
          <div class="pcm-field">
            <label>Cognome</label>
            <input type="text" data-field="cognome" placeholder="Rossi" value="${p.cognome || ''}">
          </div>
          <div class="pcm-field pcm-field--full">
            <label>Email</label>
            <input type="email" data-field="email" placeholder="mario.rossi@email.com" value="${p.email || ''}">
          </div>
        </div>
      `;
      container.appendChild(group);
    }

    const removed = participants[newQty];
    if (removed) {
      const group = document.createElement('div');
      group.className = 'pcm-group pcm-group--removed';
      group.innerHTML = `
        <div class="pcm-group-heading">
          <div class="pcm-group-number pcm-group-number--removed">${newQty + 1}</div>
          <span>Partecipante ${newQty + 1}</span>
          <span class="pcm-group-badge pcm-group-badge--remove">Verrà rimosso</span>
        </div>
        <div class="pcm-group-fields">
          <div class="pcm-field">
            <label>Nome</label>
            <input type="text" value="${removed.nome || ''}" disabled>
          </div>
          <div class="pcm-field">
            <label>Cognome</label>
            <input type="text" value="${removed.cognome || ''}" disabled>
          </div>
          <div class="pcm-field pcm-field--full">
            <label>Email</label>
            <input type="email" value="${removed.email || ''}" disabled>
          </div>
        </div>
      `;
      container.appendChild(group);
    }
  }

  function collectParticipants(container) {
    const groups = container.querySelectorAll('.pcm-group:not(.pcm-group--removed)');
    return Array.from(groups).map(g => ({
      nome:    g.querySelector('[data-field="nome"]').value.trim(),
      cognome: g.querySelector('[data-field="cognome"]').value.trim(),
      email:   g.querySelector('[data-field="email"]').value.trim(),
    }));
  }

  function allFilled(participants) {
    return participants.every(p => p.nome && p.cognome && p.email);
  }

  // -------------------------
  // CART UPDATE
  // -------------------------

  function updateCartItem(itemKey, newQty, properties) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemKey,
        quantity: newQty,
        properties: properties
      })
    })
    .then(r => r.json())
    .then(() => {
      if (window.location.pathname === '/cart') {
        window.location.reload();
        return;
      }
      // Aggiorna drawer via sections API
      return fetch('/?sections=cart-drawer,cart-bubble')
        .then(r => r.json())
        .then(sections => {
          if (sections['cart-drawer']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = sections['cart-drawer'];
            const drawerInner = document.querySelector('#Cart-Drawer .side-panel-inner');
            const newInner = tmp.querySelector('.side-panel-inner');
            if (drawerInner && newInner) {
              drawerInner.innerHTML = newInner.innerHTML;
            }
          }
          if (sections['cart-bubble']) {
            const tmp = document.createElement('div');
            tmp.innerHTML = sections['cart-bubble'];
            const bubble = document.querySelector('.cart-bubble, [data-cart-bubble]');
            const newBubble = tmp.querySelector('.cart-bubble, [data-cart-bubble]');
            if (bubble && newBubble) {
              bubble.innerHTML = newBubble.innerHTML;
            }
          }
        });
    });
  }

  // -------------------------
  // SUBMIT UPDATE
  // -------------------------

  function submitUpdate(btn, itemKey, newQty, properties) {
    btn.disabled = true;
    btn.querySelector('span').textContent = 'Aggiornamento...';
    updateCartItem(itemKey, newQty, properties)
      .then(() => {
        closeModal();
        btn.disabled = false;
      })
      .catch(() => {
        btn.disabled = false;
        btn.querySelector('span').textContent = 'Conferma e aggiorna carrello';
      });
  }

  // -------------------------
  // INTERCEPT +/- CLICK
  // -------------------------

  function hasParticipants(itemEl) {
    return !!itemEl.querySelector('.participant-cart-list');
  }

  function getItemKey(quantitySelector) {
    return quantitySelector.dataset.id;
  }

  function interceptQuantityClick(e) {
    const plusBtn  = e.target.closest('.plus');
    const minusBtn = e.target.closest('.minus');
    if (!plusBtn && !minusBtn) return;

    const quantitySelector = (plusBtn || minusBtn).closest('quantity-selector');
    if (!quantitySelector) return;

    const itemEl = quantitySelector.closest('.product-cart-item, tr[id^="CartItem-"]');
    if (!itemEl) return;

    if (!hasParticipants(itemEl)) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    const itemKey    = getItemKey(quantitySelector);
    const currentQty = parseInt(quantitySelector.querySelector('input').value) || 1;
    const isPlus     = !!plusBtn;
    const newQty     = isPlus ? currentQty + 1 : Math.max(1, currentQty - 1);

    if (newQty === currentQty) return;

    createModal();
    openModal();

    const modal      = document.getElementById('participant-cart-modal');
    const body       = modal.querySelector('.pcm-body');
    const errorEl    = modal.querySelector('.pcm-error');
    const confirmBtn = modal.querySelector('.pcm-confirm');

    body.innerHTML = '<div class="pcm-loading">Caricamento...</div>';
    errorEl.classList.remove('is-visible');

    modal.querySelector('.pcm-title').textContent = isPlus
      ? 'Aggiungi partecipante'
      : 'Rimuovi partecipante';

    getParticipantProps(itemKey).then(data => {
      if (!data) return;
      const existing = parseParticipants(data.properties);

      if (isPlus) {
        renderGroups(body, existing, newQty);
      } else {
        renderGroupsWithRemoval(body, existing, newQty);
      }

      const newConfirm = confirmBtn.cloneNode(true);
      confirmBtn.parentNode.replaceChild(newConfirm, confirmBtn);

      newConfirm.querySelector('span').textContent = isPlus
        ? 'Conferma e aggiungi partecipante'
        : 'Conferma e rimuovi partecipante';

      newConfirm.addEventListener('click', function() {
        if (isPlus) {
          const participants = collectParticipants(body);
          if (!allFilled(participants)) {
            errorEl.classList.add('is-visible');
            return;
          }
          errorEl.classList.remove('is-visible');
          const properties = buildPropertiesFromParticipants(participants);
          submitUpdate(newConfirm, itemKey, newQty, properties);
        } else {
          const participants = collectParticipants(body);
          const properties   = buildPropertiesFromParticipants(participants);
          submitUpdate(newConfirm, itemKey, newQty, properties);
        }
      });
    });
  }

  document.addEventListener('click', interceptQuantityClick, true);

  // -------------------------
  // CSS
  // -------------------------

  const style = document.createElement('style');
  style.textContent = `
    .pcm-overlay {
      display: none;
      position: fixed;
      inset: 0;
      z-index: 99999;
      background: rgba(0,0,0,0.5);
      align-items: center;
      justify-content: center;
      padding: 16px;
    }
    .pcm-overlay.is-open {
      display: flex;
    }
    .pcm-dialog {
      background: var(--color-background, #fff);
      border-radius: 12px;
      width: 100%;
      max-width: 520px;
      max-height: 75vh;
      display: flex;
      flex-direction: column;
      box-shadow: 0 20px 60px rgba(0,0,0,0.2);
    }
    .pcm-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 24px 16px;
      border-bottom: 1px solid rgba(0,0,0,0.08);
      flex-shrink: 0;
    }
    .pcm-title {
      font-weight: 700;
      font-size: 16px;
    }
    .pcm-close {
      background: none;
      border: none;
      cursor: pointer;
      font-size: 18px;
      opacity: 0.5;
      padding: 4px;
      line-height: 1;
    }
    .pcm-close:hover { opacity: 1; }
    .pcm-body {
      overflow-y: auto;
      padding: 20px 24px;
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
    .pcm-loading {
      text-align: center;
      opacity: 0.5;
      padding: 32px 0;
    }
    .pcm-group {
      border: 1px solid rgba(0,0,0,0.1);
      border-radius: 8px;
      padding: 16px;
    }
    .pcm-group--new {
      border-color: var(--color-accent, #000);
      border-width: 2px;
    }
    .pcm-group--removed {
      opacity: 0.45;
      border-color: #E31E24;
      border-style: dashed;
      pointer-events: none;
    }
    .pcm-group-heading {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;
      font-weight: 600;
      font-size: 13px;
    }
    .pcm-group-number {
      width: 22px;
      height: 22px;
      border-radius: 50%;
      background: var(--color-foreground, #000);
      color: var(--color-background, #fff);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      font-weight: 700;
      flex-shrink: 0;
    }
    .pcm-group-number--removed {
      background: #E31E24;
    }
    .pcm-group-badge {
      margin-left: auto;
      font-size: 10px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      background: var(--color-accent, #000);
      color: var(--color-background, #fff);
      padding: 2px 8px;
      border-radius: 20px;
    }
    .pcm-group-badge--remove {
      background: #E31E24;
    }
    .pcm-group-fields {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
    }
    .pcm-field--full {
      grid-column: 1 / -1;
    }
    .pcm-field label {
      display: block;
      font-size: 11px;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      margin-bottom: 4px;
      opacity: 0.6;
    }
    .pcm-field input {
      width: 100%;
      border: 1px solid rgba(0,0,0,0.2);
      border-radius: 6px;
      padding: 8px 10px;
      font-size: 16px;
      background: var(--color-background, #fff);
      color: var(--color-foreground, #000);
      box-sizing: border-box;
    }
    .pcm-field input:focus {
      outline: none;
      border-color: var(--color-foreground, #000);
    }
    .pcm-footer {
      padding: 16px 24px 20px;
      border-top: 1px solid rgba(0,0,0,0.08);
      flex-shrink: 0;
    }
    .pcm-error {
      display: none;
      color: #E31E24;
      font-size: 12px;
      margin-bottom: 10px;
    }
    .pcm-error.is-visible { display: block; }
    .pcm-confirm {
      width: 100%;
    }
    .pcm-confirm:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
    @media (max-width: 480px) {
      .pcm-group-fields {
        grid-template-columns: 1fr;
      }
      .pcm-field--full {
        grid-column: 1;
      }
    }
  `;
  document.head.appendChild(style);

})();